import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import auth from './plugins/auth'
import 'fontawesome-4.7/css/font-awesome.css'
import '@/assets/scss/bootstrap.scss'

createApp(App).use(store).use(router).use(auth).mount('#app')
